import { ColumnTypes } from '../common/table/type';

export const getColumns = (): ColumnTypes => [
	{
		title: '사업장',
		dataIndex: 'workplace',
		key: 'workplace',
		align: 'center',
		width: 190,
		render: (value: string) => (
			<span title={value} className="line-clamp-1">
				{value}
			</span>
		),
	},
	{
		title: '근무 기간',
		dataIndex: 'period',
		key: 'period',
		align: 'center',
		width: 290,
		render: (value: string) => (
			<span title={value} className="line-clamp-1">
				{value}
			</span>
		),
	},
	{
		title: '비고',
		dataIndex: 'note',
		key: 'note',
		align: 'center',
		width: 190,
		render: (value: string) => (
			<span title={value} className="line-clamp-1">
				{value}
			</span>
		),
	},
];

export const HEADER_HEIGHT = 40;
export const TH_HEIGHT = 48;
export const TR_HEIGHT = 52;
